"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var highcharts_1 = __importDefault(require("highcharts"));
var highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
var utils_1 = require("../utils");
var ACChart = function (props) {
    var _a = props.type, type = _a === void 0 ? '' : _a, _b = props.styles, styles = _b === void 0 ? {} : _b, _c = props.options, options = _c === void 0 ? {} : _c, _d = props.categories, categories = _d === void 0 ? [] : _d;
    var getConfig = function () {
        var _a, _b, _c, _d, _e;
        try {
            if (!type || ['areaspline', 'area', 'spline'].includes(type)) {
                var title = options.title, subtitle = options.subtitle, _f = options.showLegends, showLegends = _f === void 0 ? true : _f, _g = options.tooltipShared, tooltipShared = _g === void 0 ? true : _g, _h = options.showMarker, showMarker = _h === void 0 ? true : _h, _j = options.showXLine, showXLine = _j === void 0 ? true : _j, _k = options.showXGrid, showXGrid = _k === void 0 ? false : _k, _l = options.showYGrid, showYGrid = _l === void 0 ? true : _l, _m = options.tooltipPrefix, tooltipPrefix = _m === void 0 ? '' : _m, _o = options.tooltipSuffix, tooltipSuffix = _o === void 0 ? '' : _o, height = options.height, xAxis = options.xAxis, yAxis = options.yAxis;
                var data_1 = (props === null || props === void 0 ? void 0 : props.value) || [];
                var injectGradientStyles = function () {
                    var defaultColors = highcharts_1.default.getOptions().colors || [];
                    return data_1.map(function (d, index) {
                        var _a;
                        // Use series-provided color or fallback to Highcharts default color
                        var baseColor = ((_a = d === null || d === void 0 ? void 0 : d.color) === null || _a === void 0 ? void 0 : _a.includes('#'))
                            ? d.color
                            : defaultColors[index % defaultColors.length];
                        return __assign(__assign({}, d), { color: baseColor, fillColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                                stops: [
                                    [0, highcharts_1.default.color(baseColor).setOpacity(0.3).get('rgba')],
                                    [1, highcharts_1.default.color(baseColor).setOpacity(0).get('rgba')],
                                ],
                            } });
                    });
                };
                var chartConfig = {
                    height: height,
                    backgroundColor: 'transparent',
                    style: styles === null || styles === void 0 ? void 0 : styles.chart,
                };
                if (type) {
                    chartConfig['type'] = type;
                }
                var config = {
                    chart: chartConfig,
                    title: {
                        text: title,
                        align: (_a = styles === null || styles === void 0 ? void 0 : styles.title) === null || _a === void 0 ? void 0 : _a.align,
                        style: styles === null || styles === void 0 ? void 0 : styles.title,
                    },
                    subtitle: {
                        text: subtitle,
                        align: (_b = styles === null || styles === void 0 ? void 0 : styles.subtitle) === null || _b === void 0 ? void 0 : _b.align,
                        style: styles === null || styles === void 0 ? void 0 : styles.subtitle,
                    },
                    legend: {
                        enabled: showLegends,
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle',
                    },
                    xAxis: {
                        categories: Array.isArray(xAxis === null || xAxis === void 0 ? void 0 : xAxis.categories)
                            ? xAxis.categories
                            : categories,
                        title: {
                            text: (xAxis === null || xAxis === void 0 ? void 0 : xAxis.title) || '',
                        },
                        labels: {
                            style: styles === null || styles === void 0 ? void 0 : styles.xAxis,
                        },
                        tickmarkPlacement: 'on',
                        gridLineWidth: showXGrid ? 1 : 0,
                        lineWidth: showXLine ? 1 : 0,
                    },
                    yAxis: {
                        title: {
                            text: yAxis === null || yAxis === void 0 ? void 0 : yAxis.title,
                        },
                        labels: {
                            style: styles === null || styles === void 0 ? void 0 : styles.yAxis,
                        },
                        min: 0,
                        gridLineWidth: showYGrid ? 1 : 0,
                    },
                    tooltip: {
                        shared: tooltipShared,
                        valueSuffix: tooltipSuffix,
                        valuePrefix: tooltipPrefix,
                    },
                    credits: {
                        enabled: false,
                    },
                    plotOptions: {
                        areaspline: {
                            fillOpacity: 0.3,
                            pointPlacement: 'on',
                            marker: {
                                enabled: showMarker,
                                radius: 4,
                            },
                        },
                        spline: {
                            fillOpacity: 0.3,
                            marker: {
                                enabled: showMarker,
                                radius: 4,
                            },
                        },
                    },
                    series: injectGradientStyles(),
                };
                return config;
            }
            else if (type === 'column') {
                var title = options.title, subtitle = options.subtitle, _p = options.showLegends, showLegends = _p === void 0 ? true : _p, _q = options.tooltipPrefix, tooltipPrefix_1 = _q === void 0 ? '' : _q, _r = options.tooltipSuffix, tooltipSuffix_1 = _r === void 0 ? '' : _r, _s = options.valueType, valueType_1 = _s === void 0 ? '' : _s, height = options.height, xAxis = options.xAxis, yAxis = options.yAxis, stacking = options.stacking, _t = options.showXLine, showXLine = _t === void 0 ? true : _t, _u = options.showTotal, showTotal_1 = _u === void 0 ? false : _u, _v = options.dataLabelsEnabled, dataLabelsEnabled = _v === void 0 ? false : _v, _w = options.marginTop, marginTop = _w === void 0 ? 50 : _w;
                var data = Array.isArray(props === null || props === void 0 ? void 0 : props.value)
                    ? JSON.parse(JSON.stringify(props === null || props === void 0 ? void 0 : props.value))
                    : [];
                var chartConfig = {
                    height: height,
                    backgroundColor: 'transparent',
                    marginTop: marginTop,
                    style: styles === null || styles === void 0 ? void 0 : styles.chart,
                };
                if (type) {
                    chartConfig['type'] = type;
                }
                return {
                    chart: chartConfig,
                    title: {
                        text: title,
                        align: (_c = styles === null || styles === void 0 ? void 0 : styles.title) === null || _c === void 0 ? void 0 : _c.align,
                        style: styles === null || styles === void 0 ? void 0 : styles.title,
                    },
                    subtitle: {
                        text: subtitle,
                        align: (_d = styles === null || styles === void 0 ? void 0 : styles.subtitle) === null || _d === void 0 ? void 0 : _d.align,
                        style: styles === null || styles === void 0 ? void 0 : styles.subtitle,
                    },
                    legend: {
                        enabled: showLegends,
                        align: 'right',
                        verticalAlign: 'top',
                        x: 4,
                        y: -5,
                        itemStyle: styles === null || styles === void 0 ? void 0 : styles.legend,
                        floating: true,
                    },
                    xAxis: {
                        type: xAxis === null || xAxis === void 0 ? void 0 : xAxis.type,
                        categories: (xAxis === null || xAxis === void 0 ? void 0 : xAxis.type) === 'category' ? null : Array.isArray(xAxis === null || xAxis === void 0 ? void 0 : xAxis.categories)
                            ? xAxis.categories
                            : categories,
                        title: {
                            text: (xAxis === null || xAxis === void 0 ? void 0 : xAxis.title) || '',
                        },
                        labels: {
                            style: styles === null || styles === void 0 ? void 0 : styles.xAxis,
                        },
                        crosshair: true,
                        lineWidth: showXLine ? 1 : 0,
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: yAxis === null || yAxis === void 0 ? void 0 : yAxis.title,
                        },
                        labels: {
                            style: styles === null || styles === void 0 ? void 0 : styles.yAxis,
                        },
                    },
                    credits: {
                        enabled: false,
                    },
                    tooltip: {
                        shared: true,
                        formatter: function () {
                            var _a, _b, _c, _d;
                            var tooltip = "<b>".concat((this === null || this === void 0 ? void 0 : this.name) || (this === null || this === void 0 ? void 0 : this.category)).concat(showTotal_1 ? " - (".concat(tooltipPrefix_1).concat(this.stackTotal).concat(tooltipSuffix_1, ")") : '', "</b><br/>");
                            (_a = this.points) === null || _a === void 0 ? void 0 : _a.forEach(function (point) {
                                var _a, _b;
                                var value = point.y;
                                var valueText = (_a = "".concat(tooltipPrefix_1).concat(value).concat(tooltipSuffix_1)) === null || _a === void 0 ? void 0 : _a.trim();
                                if (valueType_1 === 'currency') {
                                    value = utils_1.Utils.formatCurrency(point.y);
                                    valueText = (_b = "".concat(value).concat(tooltipSuffix_1)) === null || _b === void 0 ? void 0 : _b.trim();
                                }
                                ;
                                tooltip += "<span style=\"color:".concat(point.color, "\">\u25CF</span> ").concat(point.series.name, ": ").concat(valueText, "<br/>");
                            });
                            var painScore = (_d = (_c = (_b = this.points) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.point) === null || _d === void 0 ? void 0 : _d.painScore;
                            if (painScore !== undefined) {
                                tooltip += "<span style=\"color:#e74c3c\">\u25CF</span> Pain Score: <b>".concat(painScore, "/10</b>");
                            }
                            return tooltip;
                        },
                    },
                    plotOptions: {
                        column: {
                            stacking: stacking,
                            dataLabels: {
                                enabled: dataLabelsEnabled,
                            },
                            pointPadding: 0.1,
                            borderWidth: 0,
                        },
                        spline: {
                            lineWidth: 2,
                            marker: {
                                enabled: true,
                                radius: 4,
                                symbol: 'circle',
                            },
                        },
                    },
                    series: __spreadArray([], data, true),
                };
            }
            else if (type === 'circular-pie') {
                var title = options.title, _x = options.tooltipPrefix, tooltipPrefix = _x === void 0 ? '' : _x, _y = options.tooltipSuffix, tooltipSuffix = _y === void 0 ? '' : _y, height = options.height;
                var value = (props === null || props === void 0 ? void 0 : props.value) || 0;
                var chartConfig = {
                    height: height,
                    backgroundColor: 'transparent',
                    style: styles === null || styles === void 0 ? void 0 : styles.chart,
                };
                if (type) {
                    chartConfig['type'] = 'pie';
                }
                var config = {
                    chart: chartConfig,
                    title: {
                        text: title,
                        verticalAlign: 'middle',
                        align: 'center',
                        x: 2,
                        y: -4,
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                    subtitle: {
                        text: (_e = "".concat(tooltipPrefix).concat(value).concat(tooltipSuffix)) === null || _e === void 0 ? void 0 : _e.trim(),
                        verticalAlign: 'middle',
                        align: 'center',
                        x: 5,
                        y: 32,
                        style: {
                            fontSize: '25px',
                            fontWeight: 'bold',
                        },
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>',
                    },
                    legend: {
                        enabled: false,
                    },
                    credits: {
                        enabled: false,
                    },
                    plotOptions: {
                        pie: {
                            borderWidth: 0,
                        },
                        series: {
                            cursor: 'pointer',
                            borderRadius: 0,
                            dataLabels: {
                                enabled: false,
                            },
                            showInLegend: false,
                        },
                    },
                    series: [
                        {
                            name: title,
                            innerSize: '60%',
                            data: [
                                {
                                    name: 'Achieved',
                                    y: value,
                                    color: '#5C67C9',
                                },
                                {
                                    name: 'Pending',
                                    y: 100 - value,
                                    color: '#b5c2fa',
                                },
                            ],
                        },
                    ],
                };
                return config;
            }
        }
        catch (error) {
            console.error(302, error);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: props.className, children: (0, jsx_runtime_1.jsx)(highcharts_react_official_1.default, { highcharts: highcharts_1.default, options: getConfig() }) }, props === null || props === void 0 ? void 0 : props.name));
};
exports.ACChart = ACChart;
